<ng-container *ngIf="hasTitleOptions; else plainTitle">
  <div class="title-picker v2-mr-1" (clickOutside)="closeTitleMenu()">
    <button type="button" class="title-trigger" data-id="title-picker" (click)="toggleTitleMenu()">
      <typography-v2 class="texts">{{ title }}</typography-v2>
      <rdr-svg-icon key="chevron-bottom" size="sm" class="v2-ml-1"></rdr-svg-icon>
    </button>

    <context-menu-v2 *ngIf="isTitleMenuOpen" class="position-absolute title-menu">
      <dropdown-item-v2
        *ngFor="let option of titleOptions"
        [attr.data-id]="option.value"
        (click)="selectTitleOption(option)"
        class="d-flex align-items-center"
        hoverClass
      >
        {{ option.label }}
      </dropdown-item-v2>
    </context-menu-v2>
  </div>
</ng-container>

<ng-template #plainTitle>
  <typography-v2 *ngIf="props.extra?.title" class="v2-mr-1 texts">{{
    props.extra?.title
  }}</typography-v2>
</ng-template>

<typography-v2 *ngIf="props.extra?.info" look="small" class="text-black-50 me-auto texts">{{
  props.extra?.info
}}</typography-v2>

<count
  (valueChange)="valueChange($event)"
  [value]="formControl.value"
  [disabled]="props.readonly"
  [key]="key"
  [min]="props.min"
/>
